<template>
  <div class="ViewPromo -mtrast" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  За 18 лет на рынке, организация проделала сложнейший путь,
                  став сегодня одним из крупнейших операторов рынка
                  горюче-смазочных материалов в Центрально-Черноземном регионе.
                </p>
                <p>
                  ООО «М-Траст» реализует все виды светлых нефтепродуктов
                  (бензины, дизельное топливо, керосины, нефрасы и т. д.).
                  Поставляемые нами нефтепродукты напрямую закупаются на
                  Рязанском НПК, Саратовском НПЗ, Волгоградском НПЗ, Ярославском
                  НОС, Ново-Уфимском НПЗ. Отгрузка продукции потребителям
                  осуществляется с 2-х собственных нефтебаз (рн. Аэропорта и п.
                  Латное), а также с наливного терминала ЛПДС-Воронеж.
                </p>
                <p>
                  Компания располагает собственным парком крупнотоннажного
                  наливного автотранспорта – более 40 ед., а также
                  специализируется на продаже смазочных материалов в крупной
                  фасовке с собственных складов и отгрузке специализированным
                  автотранспортом с нефтебаз.
                </p>
                <p>
                  Ассортимент «М-Траст» включает моторные, индустриальные,
                  гидравлические, турбинные, трансмиссионные, компрессорные,
                  трансформаторные масла, все основные технические жидкости,
                  автомобильные и промышленные смазки.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:88002223656"
                          class="ViewPromo__advantage-contact-link"
                          >8 800 222-36-56</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:sales@m-trast.ru"
                          class="ViewPromo__advantage-contact-link"
                          >sales@m-trast.ru</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базис поставок</h4>
                    <p>ЛПДС Воронеж</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «М-Траст»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 702,
    productId: 1341,
    name: 'ООО «М-Траст»',
    inn: '3664074710 ',
  }),
};
</script>

<style lang="scss">
.-mtrast .ViewPromo__logo-img {
  height: rem(20);
}
</style>
